import AdminReport from "../../components/admin/adminReports/AdminReport";

const ReportPage = () => {
  return (
    <>
      <AdminReport />
    </>
  );
};

export default ReportPage;
